<div *ngIf="student">
  <lms-breadcrumb [label]="student.fullName || student.email"></lms-breadcrumb>

  <mat-tab-group
    class="tab-group"
    #tabGroup
    animationDuration="0ms"
    disableRipple="true"
    (selectedTabChange)="setTab($event)"
  >
    <mat-tab label="data">
      <ng-template mat-tab-label> {{ 'nouns.data' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-student-editor [student]="student" (saved)="onUpdateStudent($event)"></lms-student-editor>
      </ng-template>
    </mat-tab>

    <mat-tab label="licenses">
      <ng-template mat-tab-label> {{ 'licenses.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-licenses-list
          [listId]="studentLicensesListId"
          [options]="{ filters: filters, aggregates: 'currentSublicenseId' }"
        >
        </lms-licenses-list>
      </ng-template>
    </mat-tab>

    <mat-tab *lmsProfileGuard="'students.surveys'" label="surveys">
      <ng-template mat-tab-label> {{ 'surveys.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <gl-surveys-report
          [filters]="{ userId: student.id, clientId: student.clientId }"
          [config]="{ reportFilters: false, columnChooser: false, download: false, filter: true }"
        >
        </gl-surveys-report>
      </ng-template>
    </mat-tab>

    <mat-tab label="emails">
      <ng-template mat-tab-label> {{ 'emails.label' | translate }} </ng-template>
      <ng-template matTabContent>
        <lms-toolbar [options]="toolbarConfig">
          <ng-container *ngIf="client && client.subscriptions.users">
            <gl-button
              icon
              icon-center="glicon-email"
              *lmsProfileGuard="'emails.send-mail'"
              (onClick)="sendWelcomeMail()"
              title="{{ 'notifications.manual.iconTitle.welcome' | translate }}"
            ></gl-button>
          </ng-container>
        </lms-toolbar>
        <lms-emails-list
          #emails
          [listId]="studentEmailsListId"
          [options]="{ filters: notificationFilter, timezone: timezone }"
        ></lms-emails-list>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div class="gl-context-menu__position">
    <lms-button-actions>
      <div class="gl-context-menu__options">
        <span
          class="gl-context-menu__options--item"
          (click)="resetStudentPasswordDialog()"
          *lmsProfileGuard="'students.reset-password'"
          title="{{ 'actions.resetPassword' | translate }}"
          >{{ 'actions.resetPassword' | translate }}</span
        >
        <span
          class="gl-context-menu__options--item"
          (click)="updateEmail()"
          *lmsProfileGuard="'students.change-email'"
          title="{{ 'actions.updateEmail' | translate }}"
          >{{ 'actions.updateEmail' | translate }}</span
        >
        <span
          class="gl-context-menu__options--item"
          (click)="anonymizeStudent()"
          *lmsProfileGuard="'students.anonymize'"
          title="{{ 'actions.anonymizeStudent' | translate }}"
          >{{ 'actions.anonymizeStudent' | translate }}</span
        >
        <span
          class="gl-context-menu__options--item alert"
          (click)="deleteStudent()"
          *lmsProfileGuard="'students.delete'"
          [ngClass]="{ disabled: student.role !== 'student' }"
          title="{{ 'actions.deleteStudent' | translate }}"
          >{{ 'actions.deleteStudent' | translate }}</span
        >
      </div>
    </lms-button-actions>
  </div>
</div>

<lms-student-email-editor
  #studentEmailEditor
  [student]="student"
  (studentEmailChanged)="onStudentEmailChanged($event)"
></lms-student-email-editor>
